let Constants = {
	PROMO_CODE: "642",
	CH_PROMO: "CH_642_MLB_WEB_MATTONCI22_CRS_NAV_20220110_20220313",
	CLOSING_STEP_1_DATE: "13/03/2022 18:00",
	CLOSING_STEP_2_DATE: "28/03/2022 18:00",
	API_PROMOCODE: "mattoncino-2022"
}

export default Constants;
